import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SvgComponent = (props: SvgProps) => (
  <Svg
    viewBox="0 0 24 24"
    {...props}
    fill="none"
  >
    <Path
      stroke={props.fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 5v14m8-14v14"
    />
  </Svg>
)
export default SvgComponent
